export default {
    onOffersData(response) {
        if (response && response.data) {
            this.offersData = response.data;
        }
    },
};
